/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('CreateUpdatePublicFolderLinkModal', [
        'PublicFolderLinkModal',
        'PublicFolderLinkResource',
        'publicFolderLinkShareModal',
        function (
            PublicFolderLinkModal,
            PublicFolderLinkResource,
            publicFolderLinkShareModal
        ) {
            return function (node) {
                var isCreatingLink = false;

                PublicFolderLinkResource.get({ node_uuid: node.uuid }).$promise
                    .then(function (publicFolderData) {
                        isCreatingLink = angular.isUndefined(publicFolderData.page_url);

                        return PublicFolderLinkModal(node, publicFolderData);
                    })
                    .then(function (publicFolderData) {
                        if (isCreatingLink) {
                            publicFolderLinkShareModal(publicFolderData);
                        }
                    });
            }
        }
    ]);
